import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { getBuildingFormSchema } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { z } from "zod";

export const getHouseFormSchema = (t: TranslateFunction) =>
	getBuildingFormSchema(t, ClientPropertyTypeEnum.House);

export type HouseFormInput = z.input<ReturnType<typeof getHouseFormSchema>>;
export type HouseFormOutput = z.output<ReturnType<typeof getHouseFormSchema>>;
